import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterEnvironmentalLabelsSearchValueObject extends ValueObject {
  #environmentalLabels

  constructor({environmentalLabels}) {
    super()
    this.#environmentalLabels = environmentalLabels
  }

  static create({environmentalLabels}) {
    return new FilterEnvironmentalLabelsSearchValueObject({
      environmentalLabels: FilterIdsArraySearchValueObject.create(environmentalLabels)
    })
  }

  static createWithDefaultValue({config, environmentalLabels}) {
    const {DEFAULT_ENVIRONMENTAL_LABELS_SEARCH} = config.get('searchFilters')

    return new FilterEnvironmentalLabelsSearchValueObject({
      environmentalLabels: FilterIdsArraySearchValueObject.create({
        value: environmentalLabels ?? DEFAULT_ENVIRONMENTAL_LABELS_SEARCH
      })
    })
  }

  static createQueryParams({config, environmentalLabels}) {
    const {DEFAULT_ENVIRONMENTAL_LABELS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterEnvironmentalLabelsSearchValueObject({
      environmentalLabels: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.ENVIRONMENTAL_LABEL],
        value: environmentalLabels ?? DEFAULT_ENVIRONMENTAL_LABELS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#environmentalLabels.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#environmentalLabels.queryParam})
    }
  }

  get value() {
    return this.#environmentalLabels.value
  }

  toJSON() {
    return {
      environmentalLabels: this.#environmentalLabels.toJSON()
    }
  }
}
